import { processItems } from '../../../../node_modules/@cloudscape-design/collection-hooks/mjs/operations';
import { FREE_TEXT_CONDITION_OPERATORS } from './conditionOperators';

// CUS-12. Free-text keys only: enumerable and id-matched keys must stay
// byte-exact, or one side desyncs from the other.
export const normalizeFreeTextValue = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map((v) =>
      typeof v === 'string' ? v.toLowerCase().trim() : v
    ) as T;
  }

  return (typeof value === 'string' ? value.toLowerCase().trim() : value) as T;
};

const FREE_TEXT_PROPERTY_KEY = 'value';

const declaredOperators = new Set(
  FREE_TEXT_CONDITION_OPERATORS.map((op) =>
    typeof op === 'string' ? op : op.operator
  )
);

// `filterByToken` resolves an undeclared operator to false; callers matching
// outside `processItems` must reject the same set.
export const isDeclaredFreeTextOperator = (operator: string): boolean =>
  declaredOperators.has(operator);

const freeTextFilteringProperties = [
  {
    key: FREE_TEXT_PROPERTY_KEY,
    propertyLabel: '',
    groupValuesLabel: '',
    operators: [...FREE_TEXT_CONDITION_OPERATORS],
  },
];

// One token through Cloudscape's own matcher, so this and the live path
// (`conditionsGraph.getHiddenFields`) share operator semantics (CUS-38,
// CUS-380).
export const matchesFreeTextToken = ({
  itemValue,
  tokenValue,
  operator,
}: {
  itemValue: unknown;
  tokenValue: unknown;
  operator: string;
}): boolean => {
  const query = {
    operation: 'and' as const,
    tokens: [],
    tokenGroups: [
      {
        propertyKey: FREE_TEXT_PROPERTY_KEY,
        operator,
        value: normalizeFreeTextValue(tokenValue),
      },
    ],
  };

  const { items } = processItems(
    [{ [FREE_TEXT_PROPERTY_KEY]: normalizeFreeTextValue(itemValue) }],
    { propertyFilteringQuery: query },
    { propertyFiltering: { filteringProperties: freeTextFilteringProperties } }
  );

  return items.length > 0;
};
